var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAvatar5 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1906",
    "data-name": "Group 1906",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_673",
    "data-name": "Ellipse 673",
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#f4f4f4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1868",
    "data-name": "Group 1868"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_672",
    "data-name": "Ellipse 672",
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_296",
    "data-name": "Mask Group 296",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1867",
    "data-name": "Group 1867",
    transform: "translate(5.127 11.961)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44292",
    "data-name": "Path 44292",
    d: "M-2317.973,2528.037a27.436,27.436,0,0,0-12.848,5.367c-5.807,4.641-10.785,12.191-10.785,12.191l2.639,10.823,38.011,7.568,22.926-23.809s-6.789-6.641-13.954-9.789a32.321,32.321,0,0,0-14.128-2.566s-4.194,4.553-7.207,4.664S-2317.973,2528.037-2317.973,2528.037Z",
    transform: "translate(2341.606 -2501.499)",
    fill: "#9eb4b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44293",
    "data-name": "Path 44293",
    d: "M-2323.991,2518.607a32.864,32.864,0,0,0,.115,4.526,4.632,4.632,0,0,0,4.786,2.86c2.833-.16,4.465-.556,6.292-3.522a7.69,7.69,0,0,0,.713-1.622,16.456,16.456,0,0,0,.487-6.318,1.462,1.462,0,0,0,1.872.308c.376-.17,1.086-2.038,1.141-3.416a3.617,3.617,0,0,0-1.324-3.215c-.622-.457-1.712-.427-1.927-.855a8.429,8.429,0,0,0-5.93-3.095,6.259,6.259,0,0,0-5.96,2.92c-1.538,2.053-.124,5.5-.124,5.5s1.247-4.173,3.91-4.474a7.033,7.033,0,0,1,6.162,3.215,12.68,12.68,0,0,1,.669,5.561c-.231,1.227-1.489,1.6-3.11,1.836A71.372,71.372,0,0,1-2323.991,2518.607Z",
    transform: "translate(2344.466 -2504.252)",
    fill: "#27160f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44294",
    "data-name": "Path 44294",
    d: "M-2324.05,2518.225a7.432,7.432,0,0,1,0-1.776c-.029-1.577.21-4.485.21-4.485s.783-4.546,5.117-4.456,5.72,4.274,5.72,4.274a14.643,14.643,0,0,1,.15,3.221,3.813,3.813,0,0,1-1.565,3.221c-1.188.722-2.93.364-5.058.421C-2321.437,2518.707-2323.724,2518.962-2324.05,2518.225Z",
    transform: "translate(2344.521 -2503.71)",
    fill: "#e7b09c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44295",
    "data-name": "Path 44295",
    d: "M-2321.312,2529.4a7.805,7.805,0,0,0,1.076-2.041,10.688,10.688,0,0,0,.372-2.83,12.063,12.063,0,0,0,3.6-.592c1.094-.535,2.5-1.6,3.576-4.405s-.008-6.238.592-6.47,2.891-.308,2.915,1.9-1.754,2.417-2.275,3.317a38.9,38.9,0,0,0,.332,6.826,9.159,9.159,0,0,0,1.658,4.08s-4.384,5.581-7.345,5.636S-2321.312,2529.4-2321.312,2529.4Z",
    transform: "translate(2344.987 -2502.803)",
    fill: "#e7b09c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44300",
    "data-name": "Path 44300",
    d: "M5361.508,1876.682a3.142,3.142,0,0,1,1.466-.413,4.944,4.944,0,0,1,1.706.413",
    transform: "translate(-5334.603 -1868.322)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44301",
    "data-name": "Path 44301",
    d: "M5362.184,1876.75a7.571,7.571,0,0,1,1.379-.219,6.023,6.023,0,0,1,1.3.1",
    transform: "translate(-5341.679 -1868.391)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_670",
    "data-name": "Ellipse 670",
    transform: "translate(21.221 9.586)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.778,
    cy: 0.778,
    rx: 0.778,
    ry: 0.778,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.778,
    cy: 0.778,
    rx: 0.278,
    ry: 0.278,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_671",
    "data-name": "Ellipse 671",
    transform: "translate(27.62 9.586)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.778,
    cy: 0.778,
    rx: 0.778,
    ry: 0.778,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.778,
    cy: 0.778,
    rx: 0.278,
    ry: 0.278,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_44302",
    "data-name": "Path 44302",
    d: "M5358.66,1880.152a14.356,14.356,0,0,0-1.317,3c.027.543,1.483.606,1.483.606Z",
    transform: "translate(-5333.519 -1869.331)",
    fill: "#d59b85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44303",
    "data-name": "Path 44303",
    d: "M5357.654,1886.389l4.044-.062s-1.188,1.571-2.2,1.587S5357.654,1886.389,5357.654,1886.389Z",
    transform: "translate(-5334.877 -1869.22)",
    fill: "#fff"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAvatar5, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/avatar-5.2b94ed8b.svg";
export { ForwardRef as ReactComponent };